var MpBackdrop;

(function() {
    'use strict';
    if (!document.querySelector('#vue-backdrop')) {
        return;
    }

    MpBackdrop = new Vue({
        el: '#vue-backdrop',
        data: function() {
            return {
                initialized: false,
            };
        },
        computed: {},
        methods: {
            closeMenu: function() {
                MpEventBus.$emit('closeMenu');
            },

            init: function() {
                this.$el.addEventListener('click', this.closeMenu );
            },
        },
        mounted: function() {
            this.init();
        },
        updated: function() {
            if (!this.initialized) {
                this.init();
            }
        },
    });
})();
